import React from "react";
import { Theme } from "@material-ui/core";
import Button from "../../../../components/Button";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AdapterLink } from "../../../../components/Adopter";
import { useQuery } from "react-query";
import useExamQueries from "../../hooks/useExamQueries";
import { mutateErrors } from "../../../../utils";
import Error from "../../../../components/Error";
import PageHeader from "../../../../components/PageHeader";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";
import ExamListItem from "../../components/ExamListItem";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListPage() {
  const classes = useStyles();
  const { fetchAll } = useExamQueries();
  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("exams", fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Exams"}
          subtitle={"Here are listed program exams"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${Routes.EXAMS}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((exam: any, index) => (
              <ExamListItem
                onDelete={refetch}
                index={index}
                exam={exam}
                key={`ExamListItem_${index}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}
